import { styled } from '@linaria/react'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { COLOR } from 'vars/index'
import { MEDIA } from 'vars/media'

export const SearchHintSC = styled.div<{ isFullyVisible?: boolean }>`
  opacity: ${({ isFullyVisible = true }) => (isFullyVisible ? 1 : 0.3)};
  transition: opacity 0.2s ease;
  cursor: pointer;

  display: flex;
  align-items: center;
  gap: var(${FIXED_INDENTS.INDENT_20});
  padding: var(${FIXED_INDENTS.INDENT_20}) var(${FIXED_INDENTS.INDENT_30});
  border-radius: 64px;
  border: 1px solid var(${COLOR.ACCENT_TERTIARY});

  ${MEDIA.NO_TOUCH} {
    &:hover {
      border: ${({ isFullyVisible }) =>
        isFullyVisible
          ? `1px solid var(${COLOR.TEXT_ICON_PRIMARY})`
          : `1px solid var(${COLOR.ACCENT_TERTIARY})`};
    }
  }

  ${MEDIA.MIN_600} {
    gap: var(${FIXED_INDENTS.INDENT_30});
    padding: var(${FIXED_INDENTS.INDENT_20}) var(${FIXED_INDENTS.INDENT_40});
  }
`
